<template>
  <Form @submit="$emit('submit', area)" :title="$t('meta.baseData')" bodyClass="">
    <FormInput :name="$t('areas.name')" v-model="area.name" required />
    <FormInput :name="$t('areas.externalId')" v-model="area.external_id" labelOptional />
    <FormInput :name="$t('areas.description')" v-model="area.description" labelOptional />
    <BaseMap
      :allowFourNewCoordinatesOnly="isNew"
      :editablePolygonFeature="geojsonFeature"
      :staticPolygons="staticPolygonsForMap"
      :fitBounds="(areaPolygon || sitePolygon).properties.bbox"
      :parentPolygon="sitePolygon"
      :childPolygons="zonesPolygons"
      :enableDraw="isNew"
      :zoomedOut="isNew"
      @coordinates-updated="handleCoordinatesUpdate"
      @coordinates-reset="resetCoordinates"
      enableGeocoder
    />
    <div class="form-wrap">
      <span class="label">{{ $t('meta.sitePlan') }} {{ `(${$t('meta.optional')})` }}</span>
      <ImageUpload v-model="area.image" :label="$t('imageUpload.add.area')" />
    </div>
    <Button type="submit" :disabled="submitDisabled">{{ isNew ? $t('areas.createArea') : $t('areas.update') }}</Button>
  </Form>
</template>

<script>
import Button from '@/components/Button/index.vue'
import ImageUpload from '@/components/Form/ImageUpload.vue'
import FormInput from '@/components/Form/Input/index.vue'
import Form from '@/components/Form/index.vue'
import BaseMap from '@/components/Map/base.vue'

import { staticPolygonsFromObject } from '@/utils/geojson'
import mapUtils from '@/utils/mapbox'

export default {
  inject: ['companyUser'],
  data() {
    return {
      area: this.initialArea || {
        image: {},
        company_uuid: this.companyUser.company_uuid,
        name: null,
        mb_feature_polygon: null,
        lat: null,
        lng: null,
      },
    }
  },
  props: {
    initialArea: { type: Object },
    site: { type: Object, required: true },
    zones: { type: Array, default: () => [] },
  },
  components: {
    Button,
    Form,
    FormInput,
    ImageUpload,
    BaseMap,
  },
  methods: {
    handleCoordinatesUpdate(newCoordinates) {
      const center = mapUtils.calculateCenterOfCoordinates(mapUtils.coordinatePairArrayToLngLatObject(newCoordinates))
      this.area.mb_feature_polygon = JSON.stringify({
        type: 'FeatureCollection',
        features: [
          {
            id: this.area.uuid,
            type: 'Feature',
            properties: {},
            geometry: {
              coordinates: [newCoordinates],
              type: 'Polygon',
            },
          },
        ],
      })

      this.area.lat = center.lat
      this.area.lng = center.lng
    },
    resetCoordinates() {
      this.area.lat = null
      this.area.lng = null
    },
  },
  computed: {
    isNew() {
      return !this.area.uuid
    },
    submitDisabled() {
      const { name, mb_feature_polygon, lat, lng } = this.area
      return !name || !mb_feature_polygon || !lat || !lng
    },
    staticPolygonsForMap() {
      return [
        this.sitePolygon,
        ...(this.site.areas?.map(area => staticPolygonsFromObject('area', area)) || []),
        ...this.zonesPolygons,
      ].filter(polygon => polygon)
    },
    areaPolygon() {
      if (this.isNew) return null
      return staticPolygonsFromObject('area', this.area)
    },
    sitePolygon() {
      return staticPolygonsFromObject('site', this.site)
    },
    zonesPolygons() {
      return this.zones?.map(zone => staticPolygonsFromObject('zone', zone)) || []
    },
    geojsonFeature() {
      if (this.isNew) return null
      return JSON.parse(this.area.mb_feature_polygon).features[0]
    },
  },
}
</script>
